import { Injectable } from '@angular/core';
import { EnvironmentDataService } from './environment-data.service';
import { TranslateService } from '@ngx-translate/core';
import { log } from './util';

//https://gist.github.com/mendezcode/8275387
export const LOCALES = {
  af: "Afrikaans",
  sq: "Albanian",
  am: "Amharic",
  ar_DZ: "Arabic - Algeria",
  ar_BH: "Arabic - Bahrain",
  ar_EG: "Arabic - Egypt",
  ar_IQ: "Arabic - Iraq",
  ar_JO: "Arabic - Jordan",
  ar_KW: "Arabic - Kuwait",
  ar_LB: "Arabic - Lebanon",
  ar_LY: "Arabic - Libya",
  ar_MA: "Arabic - Morocco",
  ar_OM: "Arabic - Oman",
  ar_QA: "Arabic - Qatar",
  ar_SA: "Arabic - Saudi Arabia",
  ar_SY: "Arabic - Syria",
  ar_TN: "Arabic - Tunisia",
  ar_AE: "Arabic - United Arab Emirates",
  ar_YE: "Arabic - Yemen",
  hy: "Armenian",
  as: "Assamese",
  az_AZ: "Azeri - Cyrillic",
  eu: "Basque",
  be: "Belarusian",
  bn: "Bengali - Bangladesh",
  bs: "Bosnian",
  bg: "Bulgarian",
  my: "Burmese",
  ca: "Catalan",
  zh_CN: "Chinese - China",
  zh_HK: "Chinese - Hong Kong SAR",
  zh_MO: "Chinese - Macau SAR",
  zh_SG: "Chinese - Singapore",
  zh_TW: "Chinese - Taiwan",
  hr: "Croatian",
  cs: "Czech",
  da: "Danish",
  dv: "Divehi; Dhivehi; Maldivian",
  nl_BE: "Dutch - Belgium",
  nl_NL: "Dutch - Netherlands",
  en_AU: "English - Australia",
  en_BZ: "English - Belize",
  en_CA: "English - Canada",
  en_CB: "English - Caribbean",
  en_GB: "English - Great Britain",
  en_IN: "English - India",
  en_IE: "English - Ireland",
  en_JM: "English - Jamaica",
  en_NZ: "English - New Zealand",
  en_PH: "English - Phillippines",
  en_ZA: "English - Southern Africa",
  en_TT: "English - Trinidad",
  en_US: "English - United States",
  et: "Estonian",
  fo: "Faroese",
  fa: "Farsi - Persian",
  fi: "Finnish",
  fr_BE: "French - Belgium",
  fr_CA: "French - Canada",
  fr_FR: "French - France",
  fr_LU: "French - Luxembourg",
  fr_CH: "French - Switzerland",
  mk: "FYRO Macedonia",
  gd_IE: "Gaelic - Ireland",
  gd: "Gaelic - Scotland",
  de_AT: "German - Austria",
  de_DE: "German - Germany",
  de_LI: "German - Liechtenstein",
  de_LU: "German - Luxembourg",
  de_CH: "German - Switzerland",
  el: "Greek",
  gn: "Guarani - Paraguay",
  gu: "Gujarati",
  he: "Hebrew",
  hi: "Hindi",
  hu: "Hungarian",
  is: "Icelandic",
  id: "Indonesian",
  it_IT: "Italian - Italy",
  it_CH: "Italian - Switzerland",
  ja: "Japanese",
  kn: "Kannada",
  ks: "Kashmiri",
  kk: "Kazakh",
  km: "Khmer",
  ko: "Korean",
  lo: "Lao",
  la: "Latin",
  lv: "Latvian",
  lt: "Lithuanian",
  ms_BN: "Malay - Brunei",
  ms_MY: "Malay - Malaysia",
  ml: "Malayalam",
  mt: "Maltese",
  mi: "Maori",
  mr: "Marathi",
  mn: "Mongolian",
  ne: "Nepali",
  no_NO: "Norwegian - Bokml",
  or: "Oriya",
  pl: "Polish",
  pt_BR: "Portuguese - Brazil",
  pt_PT: "Portuguese - Portugal",
  pa: "Punjabi",
  rm: "Raeto-Romance",
  ro_MO: "Romanian - Moldova",
  ro: "Romanian - Romania",
  ru: "Russian",
  ru_MO: "Russian - Moldova",
  sa: "Sanskrit",
  sr_SP: "Serbian - Cyrillic",
  tn: "Setsuana",
  sd: "Sindhi",
  si: "Sinhala; Sinhalese",
  sk: "Slovak",
  sl: "Slovenian",
  so: "Somali",
  sb: "Sorbian",
  es_AR: "Spanish - Argentina",
  es_BO: "Spanish - Bolivia",
  es_CL: "Spanish - Chile",
  es_CO: "Spanish - Colombia",
  es_CR: "Spanish - Costa Rica",
  es_DO: "Spanish - Dominican Republic",
  es_EC: "Spanish - Ecuador",
  es_SV: "Spanish - El Salvador",
  es_GT: "Spanish - Guatemala",
  es_HN: "Spanish - Honduras",
  es_MX: "Spanish - Mexico",
  es_NI: "Spanish - Nicaragua",
  es_PA: "Spanish - Panama",
  es_PY: "Spanish - Paraguay",
  es_PE: "Spanish - Peru",
  es_PR: "Spanish - Puerto Rico",
  es_ES: "Spanish - Spain (Traditional)",
  es_UY: "Spanish - Uruguay",
  es_VE: "Spanish - Venezuela",
  sw: "Swahili",
  sv_FI: "Swedish - Finland",
  sv_SE: "Swedish - Sweden",
  tg: "Tajik",
  ta: "Tamil",
  tt: "Tatar",
  te: "Telugu",
  th: "Thai",
  bo: "Tibetan",
  ts: "Tsonga",
  tr: "Turkish",
  tk: "Turkmen",
  uk: "Ukrainian",
  ur: "Urdu",
  uz_UZ: "Uzbek - Cyrillic",
  vi: "Vietnamese",
  cy: "Welsh",
  xh: "Xhosa",
  yi: "Yiddish",
  zu: "Zulu"
}

/**
 * https://www.codeandweb.com/babeledit/tutorials/how-to-translate-your-angular-app-with-ngx-translate
 */
@Injectable()
export class LocaleDataService {

  enabledLocales;
  autodetectLocale;

  /**
   * Il locale correntemente selezionato
   */
  locale: string;
  direction: 'ltr' | 'rtl'

  timeZoneOffsetInMins: number;

  constructor(
    private _environmentDataService: EnvironmentDataService,
    private _translate: TranslateService
  ) { }

  init(){
    this.enabledLocales = this._environmentDataService.environment.getValue("enabledLocales");
    log('LocaleDataService', 'init()', 'enabledLocales', this.enabledLocales, 'blue')

    this.autodetectLocale = this._environmentDataService.environment.getValue("autodetectLocale");
    log('LocaleDataService', 'init()', 'autodetectLocale', this.autodetectLocale, 'blue')

    const systemLocale = window.navigator.language;
    log('LocaleDataService', 'init()', 'window.navigator.language', window.navigator.language, 'blue', true)

    const timeZoneName = new Date().toString().split('(')[1].split(')')[0];
    this.timeZoneOffsetInMins = (-new Date().getTimezoneOffset())/60
    
    log('LocaleDataService', 'init()', 'time zone', `${timeZoneName} (${this.timeZoneOffsetInMins>0?'+':''}${this.timeZoneOffsetInMins})`, 'blue', true)
    log('LocaleDataService', 'init()', "document.body.getAttribute('dir')", document.body.getAttribute('dir'), 'blue')

    this.setLocale(this.autodetectLocale ? systemLocale : this.enabledLocales[0]);
  }

  /**
   * Viene richiamato dall'init e da UI ad ogni cambio manuale di locale
   * @param candidateLocale 
   */
  setLocale(candidateLocale: string) {
    log('LocaleDataService', 'setLocale()', 'candidateLocale', candidateLocale, 'blue', true)
    const resolvedLocale = this._resolveLocale(candidateLocale);
    log('LocaleDataService', 'setLocale()', 'resolvedLocale', resolvedLocale, 'blue')
    this.direction = this._resolveDirection(resolvedLocale)
    log('LocaleDataService', 'setLocale()', 'resolvedDirection', this.direction, 'blue')
    this.locale = resolvedLocale;
    this._translate.setDefaultLang(resolvedLocale);
    this._translate.use(resolvedLocale);
    document.body.setAttribute('dir', this.direction)
  }

  /**
   * Risolve il locale ricevuto in input nel più vicino tra quelli disponibili, secondo la priorità espressa dall'ordine
   * degli enabledLocales.
   * L'algoritmo è il seguente:
   * 1) se enabledLocales contiene esattamente il locale in ingresso, quello diventa il locale
   * 2) altrimenti si cerca per i primi due caratteri
   * 3) altrimenti si sceglie il primo della lista
   * @param candidateLocale
   */
  _resolveLocale(candidateLocale:string): string {
    let outcome: string;
    
    if(this.enabledLocales.filter(item => candidateLocale.toLowerCase()==item).length>0)
      outcome = candidateLocale.toLowerCase();
    else {
      let candidateLocales = this._environmentDataService.environment.getValue("enabledLocales").filter(item => candidateLocale.toLowerCase().substr(0,2)==item.substr(0,2));
      if(candidateLocales.length>0) 
        outcome = candidateLocales[0];
      else
        outcome = this._environmentDataService.environment.getValue("enabledLocales")[0].toLowerCase();
    }
    return outcome;
  }

  /**
   * Risolve la direction rispetto al locale
   * @param locale
   */
  _resolveDirection(locale: string) {
    return ['ar-ae'].includes(locale) ? 'rtl' : 'ltr';
  }
}
